<template>
  <div id="list-counselor" class="list-counselor container">  
    <div class="row">
      <div class="form-group col-md-3">
        <label>Tìm kiếm</label>
        <div class="input-group mb-4">
          <input v-model="keyword" class="form-control" placeholder="Name" type="text" @change="search_counselor(keyword)">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="fa fa-search"></i></span>
          </div>        
        </div>
      </div>
    </div>
    <a class="btn button btn-primary form-group button" href="/dang-ky-lam-co-van">Thêm Cố vấn</a>    
    <div class='table-outer'>
      <div>
        <table class="table table-light" border="1">
          <thead>
            <tr>
              <th>Tên</th>
              <th>Role</th>
              <th>Email</th>
              <th>SĐT</th>
              <th>Địa chỉ</th>
              <th>Dịch vụ tư cung cấp</th>
              <th>Actions</th>
              <th>Phê duyệt</th>
              <th>Public status</th>
              <th>Ranking Score</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="counselor in list_counselors">
              <td>
                <div><a :href="'/counselor?id=' + counselor.id" target="blank">{{counselor.name}}</a></div>
                <a class="config-icon" :href="'/edit_profile?id=' + counselor.id"><i class="fa fa-cog"></i></a>
              </td>
              <td>
                <div v-for="role in counselor.role">
                  {{role}}
                </div>
              </td>
              <td>{{counselor.email}}</td>
              <td>{{counselor.phone_number}}</td>
              <td>{{counselor.address}}</td>
              <td>
                <div v-for="service in counselor.service_detail">{{service.name}}</div>
              </td>
              <td>
                <div class="button_group">
                  <!-- <a :href="'/counselor?id=' + counselor.id"  class="btn btn-info form-group">Xem</a> -->                
                  <a @click="publish(counselor.id)" class="btn btn-info form-group">publish</a>
                  <a @click="unpublish(counselor.id)" class="btn btn-danger form-group">unpublish</a>              
                  <a @click="destroy(counselor.id)" class="btn btn-danger form-group" :class="{disabled: check_disable_status(counselor.public_status)}">delete</a>
                </div>
              </td>
              <td>
                <div v-if="check_temp_info_data(counselor.temp_info)" class="row">
                  <a class="btn btn-success form-group" @click="approve_request_update_info_user(counselor.id)">Phê duyệt</a>
                  <a class="btn btn-info form-group" @click='review_data_user(counselor.id)'>Xem</a>
                </div>
                <div v-else class="row">
                  <a class="btn form-group" disabled=true>Phê duyệt</a>
                </div>
              </td>
              <td>{{counselor.public_status}}</td>
              <td>{{counselor.ranking_score}}</td>
              <!-- <pre>{{counse}}</pre> -->
            </tr>
          </tbody>
        </table>
      </div>      
    </div>    
    <base-pagination      
      :pageCount="pagination_counselor.total_page"
      :value="current_page"
      @input="pagination_counselor.current_page = $event"
    ></base-pagination>
    <detail-user-info v-if="this.show_modal_user_detail.show"
    :show_modal_user_detail="this.show_modal_user_detail"
    @close_modal="show_modal_user_detail = $event"></detail-user-info>
    <!-- <pre>{{this.}}</pre> -->
  </div>

</template>
<script>
import {mapState, mapActions, mapGetter, mapMutations} from 'vuex';
import DetailUserInfo from '../Modal/DetailUserInfo.vue';
export default{
  components:{
    DetailUserInfo
  },
  data: function(){
    return{
      keyword:'',
      show_modal_user_detail: {
        show: false,
        id: ''
      },
    }
    
  },
  computed: {
    ...mapState('vuex_admin',[
      'list_counselors'
    ]),
    ...mapState('vuex_admin',{
      pagination_counselor: state => state.pagination_counselors,
      current_page: state => state.pagination_counselors.current_page
    }),
    ...mapState('vuex_network_counselors',[
      'status_search',
      ]),
    ...mapState('services', [
      'list_services'
    ])
  },
  watch: {
    current_page(new_value, old_value){
      if (old_value != undefined){
        this.$store.dispatch('vuex_admin/list_counselors', {page: new_value, keyword: this.keyword})
      }
    }
  },
  methods: {
    unpublish: function(id){
      var data = {
        id: id,
        status: 'cancel'
      }
      this.$store.dispatch('vuex_admin/update_public_status', data)
    },
    publish: function(id){
      var data = {
        id: id,
        status: 'public'
      }
      this.$store.dispatch('vuex_admin/update_public_status', data)
    },
    destroy: function(id){
      var data = {
        id: id
      }
      this.$store.dispatch('vuex_admin/destroy_user', data)
    },
    approve_request_update_info_user: function(id){
      this.$store.dispatch('vuex_admin/approve_info_update', id)
    },
    review_data_user: function(id){
      this.show_modal_user_detail.show = true
      this.show_modal_user_detail.id = id
    },
    check_temp_info_data: function(data){      
      if (data == undefined || Object.keys(data).length === 0  )
        return false
      else
        return true
    },
    check_disable_status: function(status){
      return status != 'cancel'
    },
    search_counselor: function(keyword){
      this.$store.dispatch('vuex_admin/list_counselors', {page: this.current_page, keyword: this.keyword})
    }
  }
};
</script>
<style lang="scss" scoped>
  @import "./list_counselor"
</style>


// WEBPACK FOOTER //
// src/views/components/Admin/ListCounselor.vue